import { ApolloCustomerErrorAlert } from '@graphcommerce/magento-customer/components/ApolloCustomerError/ApolloCustomerErrorAlert'
import { useFormGqlMutation } from '@graphcommerce/react-hook-form'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { Button, Checkbox } from '@mui/material'
import { GraphQLError } from 'graphql'
import { useState } from 'react'
import { StandardButton } from '../../Button/ButtonStyles'
import { StandardTextField } from '../../TextInput/TextFieldStyles'
import { SubRoleFragment } from '../SubRole/SubRole.gql'
import { SaveSubRoleDocument } from './SaveSubRole.gql'

export const RolePermissions = [
  { id: 1, label: 'View Account Dashboard', description: 'Can see their account dashboard' },
  // { id: 2, label: "View Downloadable Products" },
  // { id: 3, label: 'View And Add Account Wishlist' },
  { id: 4, label: 'View And Add Address Book', description: 'Can view and add Account Address' },
  {
    id: 5,
    label: 'View Stored Payment Method',
    description: 'Can view the Stored Payment Methods like Credit Cards',
  },
  {
    id: 6,
    label: 'Manage Users and Roles',
    description: 'Can manage company Users and Roles',
  },
  {
    id: 7,
    label: 'View All Orders',
    description:
      'Either can see all orders of the company, of only the orders made by current user.',
  },
  // { id: 8, label: 'View Reports' },
  // { id: 9, label: 'Create a Quote' }, // This is an integration with "Magento 2 Request for Quote" BssCommmerce Extension
  // { id: 10, label: 'View all Quotes' }, // This is an integration with "Magento 2 Request for Quote" BssCommmerce Extension
  {
    id: 11,
    label: 'Place Order',
    description: 'Can go through the Checkout Process and Place Order',
  },
  // { id: 12, label: 'Place Order Waiting', description: 'Place Order Waiting' },
  // { id: 13, label: 'Approve Order Waiting', description: 'Approve Order Waiting' },
  {
    id: 14,
    label: 'Receive Order Emails',
    description: 'Will receive order confirmation and order status update emails',
  },
]

type SubRoleFormProps = {
  onComplete?: () => void
  onCancel?: () => void
  onError?: (errors: readonly GraphQLError[] | undefined) => void
  onSuccess?: (data: SubRoleFragment | null | undefined) => void
  role?: SubRoleFragment
}

export function SubRoleForm(props: SubRoleFormProps) {
  const { onComplete, onError, onSuccess, onCancel, role } = props
  const [rolesArray, setRolesArray] = useState<number[]>(
    role?.role_type ? role.role_type?.split(',').map((p) => parseInt(p)) : [1, 7],
  )

  const form = useFormGqlMutation(
    SaveSubRoleDocument,
    {
      defaultValues: {
        roleId: role?.role_id,
        roleName: role?.role_name || '',
        orderPerDay: 100000,
        maxOrderAmount: 100000,
        roleType: role?.role_type || '1,7,12',
      },
      onBeforeSubmit: (values) => ({
        ...values,
        roleType: rolesArray.join(','),
      }),
      onComplete: ({ errors, data }) => {
        if (errors?.length) {
          if (onError) onError(errors)
        } else if (onSuccess) onSuccess(data?.bssCompanyAccountSaveRole)
        if (onComplete) onComplete()
      },
    },
    { errorPolicy: 'all' },
  )

  const { handleSubmit, formState, required, error, register, watch } = form
  const submitHandler = handleSubmit((_, e) => {
    if (!formState.errors) e?.target.reset()
  })

  return (
    <>
      <form
        onSubmit={submitHandler}
        noValidate
        className='customer-address-form grid grid-cols-1 gap-x-5 gap-y-6 md:grid-cols-2'
      >
        <StandardTextField
          type='text'
          label={<Trans id='Role Name' />}
          variant='outlined'
          color='primary'
          required
          className='w-[260px] max-w-[260px]'
          size='small'
          error={!!formState.errors.roleName}
          {...register('roleName', {
            required: true,
          })}
        />

        <div />

        <div className='col-span-2'>
          <h4 className='Type-XXL-Medium mb-6'>
            <Trans id='Permissions' />
          </h4>
          {RolePermissions.map((r) => (
            <div className='mb-[15px] grid grid-cols-[10fr_90fr]'>
              <Checkbox
                onClick={() => {
                  if (rolesArray.includes(r.id)) {
                    setRolesArray([...rolesArray.filter((id) => id !== r.id)])
                  } else {
                    setRolesArray([...rolesArray, r.id])
                  }
                }}
                checked={rolesArray.includes(r.id)}
              />
              <div className='flex items-center gap-[5px]'>
                <span>{r.label}</span>
              </div>
              <div />
              <span className='text-[12px]'>{r.description}</span>
            </div>
          ))}
        </div>
        <div className='mb-[40px] mt-6 flex flex-col items-center justify-start gap-6 gap-y-5 md:flex-row'>
          <StandardButton
            type='submit'
            className='w-full max-w-[350px] bg-material-ui-blue uppercase md:w-auto'
            variant='contained'
            loading={formState.isSubmitting}
            size='small'
          >
            {i18n._('Add new role')}
          </StandardButton>
          <Button
            color='primary'
            className='w-full max-w-[350px] bg-pure-white uppercase md:w-auto'
            variant='outlined'
            onClick={onCancel}
            size='small'
          >
            {i18n._('Cancel')}
          </Button>
        </div>
      </form>

      {/* <FormActions className='flex flex-col-reverse gap-[20px] md:flex-row'>
          <Button
            type='submit'
            color='blue'
            loading={formState.isSubmitting}
            label={<Trans id='Create Role' />}
            className='w-full md:w-[120px] md:min-w-[120px]'
          />
        </FormActions> */}
      <ApolloCustomerErrorAlert error={error} />
    </>
  )
}
